module.exports = __webpack_public_path__ + "static/02-2e8ed570379749b26bf8f2b6551842aa.jpg";